/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class EpssScoreRangeQueryOperator extends models.AppSecopsScoreRangeQueryOperator {
    constructor() {
        super();
        this.setDiscriminator("EpssScoreRangeQueryOperator");
    }

    getFixupPrototypeFunction() { return EpssScoreRangeQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<EpssScoreRangeQueryOperator>): EpssScoreRangeQueryOperator {
        let obj = Object.assign(new EpssScoreRangeQueryOperator(), model);
        EpssScoreRangeQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<EpssScoreRangeQueryOperator>): EpssScoreRangeQueryOperator {
        if (!model) return null;
        return EpssScoreRangeQueryOperator.newInstance(<EpssScoreRangeQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: EpssScoreRangeQueryOperator) {
        if (!obj) return;

        models.EpssScoreRangeQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: EpssScoreRangeQueryOperator): boolean {
        if (models.AppSecopsScoreRangeQueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, EpssScoreRangeQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
